const getDotProp = (obj, desc) => {
  const arr = desc.split('.')
  while (arr.length && (obj = obj[arr.shift()]));
  return obj
}
export default getDotProp
